import {
  getSharedDriveDetails,
  listSnapshots,
  createBackup,
  listSharedDrives,
  exportSnapshot,
  restoreSnapshot
} from "@/services/api/google/recovery/shared-drive/sharedDrive";
import {defaultPagination} from "@/services/pagination";
import files from "@/store/app/google/recovery/shared-drive/data-set/file";
import exports from "@/store/app/google/recovery/shared-drive/exports";
import restores from "@/store/app/google/recovery/shared-drive/restores";
import backups from "@/store/app/google/recovery/shared-drive/backups";
import user from "@/store/app/google/recovery/shared-drive/user";
import {
  connectAws,
  connectAzure, connectBox,
  connectDropbox, connectGoogle,
  connectGoogleCloud, connectMicrosoft,
  connectS3Compatible, deleteConnection, listConnection, listRegion, listRegionsGCP
} from "@/services/api/common/connection";

const defaultState = () => ({
  sharedDrives: [],
  sharedDriveMap: {},
  listRegions: {},
  listRegionsGcp: {},
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false
  },
  search: null
});

export default {
  namespaced: true,
  actions: {
    listSharedDrives({commit, state},) {
      return listSharedDrives({
        pagination: state.pagination,
        search: state.search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        }
      })
        .then(({result, pagination}) => {
          commit('setSharedDrives', result)
          commit('setPagination', pagination)
        })
    },
    getSharedDriveDetails({commit}, sharedDriveId) {
      return getSharedDriveDetails(sharedDriveId)
        .then(sharedDrive => {
          commit('setSharedDrive', sharedDrive);
          return sharedDrive;
        })
    },
    createBackup({commit}, sharedDriveId) {
      return createBackup(sharedDriveId);
    },
    listSnapshots({commit}, {sharedDriveId, date, dateTo}) {
      return listSnapshots({sharedDriveId, date, dateTo});
    },
    exportSnapshot({commit}, data) {
      return exportSnapshot({
        ...data,
        dataType: '9'
      });
    },
    restoreSnapshot({}, data) {
      return restoreSnapshot(data);
    },
    connectAws({commit}, data) {
      return connectAws(data);
    },
    connectAzure({commit}, data) {
      return connectAzure(data);
    },
    connectS3Compatible({commit}, data) {
      return connectS3Compatible(data);
    },
    connectGoogleCloud({commit}, data) {
      return connectGoogleCloud(data);
    },
    connectDropbox({commit}, data) {
      return connectDropbox(data);
    },
    connectGoogle({commit}, data) {
      return connectGoogle(data);
    },
    connectMicrosoft({commit}, data) {
      return connectMicrosoft(data);
    },
    connectBox({commit}, data) {
      return connectBox(data);
    },
    listConnection({commit}, data) {
      return listConnection(data);
    },
    deleteConnection({commit, state}, {id}) {
      return deleteConnection(id)
    },
    listRegion({commit, state}) {

      return listRegion()
        .then(region => {
          commit('setRegion', region);
          return region;
        })
    },
    listRegionGCP({commit, state}) {
      return listRegionsGCP()
        .then(region => {
          commit('setRegionGcp', region); // Commits to new mutation
          return region;
        })
    },
  },

  mutations: {
    setSharedDrives(state, sharedDrives) {
      state.sharedDrives = sharedDrives;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state, {keepSort}) {
      if (keepSort) {
        state.pagination = {
          ...defaultPagination(),
          sortBy: state.pagination.sortBy,
          sortDescending: state.pagination.sortDescending,
        }
      } else {
        state.pagination = {
          ...defaultPagination(),
          sortBy: 'name',
          sortDescending: false
        };
      }

    },
    setSearchFiles(state, search) {
      state.search = search;
    },
    setSharedDrive(state, sharedDrive) {
      state.sharedDriveMap = {
        ...state.sharedDriveMap,
        [sharedDrive.sharedDriveId]: sharedDrive
      };
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
    setRegion(state, regions) {
      state.listRegions = regions
    },
    setRegionGcp(state, regions) {
      state.listRegionsGcp = regions
    },
  },

  getters: {
    getSharedDriveById: (state) => (id) => {
      return state.sharedDriveMap[id];
    },
    getListRegions: (state) => () => {
      if (Array.isArray(state.listRegions)) {
        return state.listRegions.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
    getListRegionsGcp: (state) => () => {
      if (Array.isArray(state.listRegionsGcp)) {
        return state.listRegionsGcp.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
  },

  state: defaultState(),

  modules: {
    files,
    exports,
    restores,
    backups,
    user
  },
}
